import React, { Component } from "react";
import
{
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Row,
    Col,
    Button,
} from "reactstrap";
import Select from "react-select";
const stateManager = require("../../utils/state/stateManager");
const navigationDialogueAction = require("../../utils/state/actions/views/navigationDialogue/navigationDialogueAction");
const commonUtility = require("../../utils/domain/commonUtility");
const saleInitializer = require('../../utils/domain/sales/saleInitializer');
const constants = require('../../utils/domain/constants');
const saleContextUtil = require("../Order/utils/saleContextUtil");
const translator = require("../../utils/translator/translator");

const customStyles = 
        {
            control: (provided, state) => ({
                ...provided,
                minHeight: '6vh',
                height: '6vh',
            }),
        };

class GuestMealDialogue extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {
            guest: null,
            dispatchType: null,
            showLoading: false,
            error: {
                fieldName: '',
                message: ''
            },
        };
        this.handleCancel = this.handleCancel.bind(this);
        this.handleGuestChange = this.handleGuestChange.bind(this);
        this.handleDispatchChange = this.handleDispatchChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.hasErrors = this.hasErrors.bind(this);
        this.guests = commonUtility.getGuests()?.map(guest => ({ label: guest.code, value: guest.code })) || [];
        this.dispatchTypeOptions = [
            { value: "DineIn", label: "DineIn" },
            { value: "TakeAway", label: "TakeAway" },
        ];
    }

    handleCancel()
    {
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
    }


    handleGuestChange = (guest) =>
    {
        this.setState({ guest: guest });
    };
    handleDispatchChange = (dispatchType) =>
    {
        this.setState({ dispatchType: dispatchType });
    };

    hasErrors()
    {
        let error;
        if (this.state.guest == null)
        {
            error = {
                fieldName: 'guest',
                message: translator.getLabel('guest_cannot_be_left_empty')
            }
        }
        else if (this.state.dispatchType == null) 
        {
            error = {
                fieldName: 'dispatch',
                message: translator.getLabel('dispatch_type_cannot_be_left_empty')
            }
        }
        else
        {
            error = {
                fieldName: '',
                message: ''
            }
        }
        return error;
    }

    openSale(guestInfo)
    {
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));

        const sale = saleInitializer.createNewSale(constants.VenueCodeProperty, guestInfo.dispatchType);
        sale.dispatchInfo = JSON.stringify(guestInfo);
        sale.paymentMethod = constants.PaymentMethodVenuePaid;
        sale.saleType = constants.SaleTypeGuestsMeal;
        
        const saleContext = saleContextUtil.instantiateSaleContext(sale, false);
        saleContextUtil.openSaleContext(saleContext);
    }

    handleSubmit(e)
    {
        e.preventDefault();
        const error = this.hasErrors();
        this.setState({ error })
        if (!error.fieldName)
        {
            var guestInfo = {};
            guestInfo.guestName = this.state.guest.value;
            guestInfo.dispatchType = this.state.dispatchType.value;
            this.openSale(guestInfo);
        }
    }
    render()
    {
        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false} size="lg">
                <ModalHeader
                    close={
                        <div>
                            <Button className="btn-cancel" onClick={this.handleCancel}>
                                {translator.getLabel('cancel')}
                            </Button>
                            &nbsp;&nbsp;
                            <Button className="btn-ok" onClick={this.handleSubmit}>
                                {translator.getLabel('save')}
                            </Button>
                        </div>
                    }
                >
                    <span className="window-title">{translator.getLabel('guestMeal')}</span>
                </ModalHeader>
                <ModalBody>
                    <Form id="openGuestForm" onSubmit={this.handleSubmit}>
                        <Row className="mb-3">
                            <Col>
                                <Select
                                    options={this.guests}
                                    onChange={this.handleGuestChange}
                                    value={this.state.guest}
                                    placeholder={translator.getLabel('guest')}
                                    isSearchable={false}
                                    styles={customStyles}
                                />
                                {this.state.error.fieldName === "guest" ? <span className="error-text">{this.state.error.message}</span> : null}
                            </Col>
                            <Col>
                                <Select
                                    options={this.dispatchTypeOptions}
                                    onChange={this.handleDispatchChange}
                                    value={this.state.dispatchType}
                                    placeholder={translator.getLabel('dispatch_type')}
                                    isSearchable={false}
                                    styles={customStyles}
                                />
                                {this.state.error.fieldName === "dispatch" ? <span className="error-text">{this.state.error.message}</span> : null}
                            </Col>
                        </Row>
                    </Form>

                </ModalBody>
            </Modal>
        );
    }
}
export default GuestMealDialogue;